import { createApp } from 'vue'
import App from './App.vue'
import "./assets/style.css"
import LottieAnimation from 'lottie-web-vue'

createApp(App).use(LottieAnimation).mount('#app')
